module.exports = __webpack_public_path__ + "static/media/programming.cb013be5.svg";